module.exports = __webpack_public_path__ + "media/images/icon_list/text_left-681fa5b8797c74093bf7314c37704159.svg";